import { useModalConfirmationContext } from 'src/app/pages/promote/pageContext';

type ModalType = Parameters<ReturnType<typeof useModalConfirmationContext>[1]['displayModal']>[0];

export function useWaitForModalResult(): (type: ModalType) => Promise<boolean> {
	const [, { displayModal, setModalResultResolveFn }] = useModalConfirmationContext();

	return async function waitForModalResult(type): Promise<boolean> {
		displayModal(type);
		// eslint-disable-next-line promise/avoid-new
		return new Promise<boolean>((resolve) => {
			setModalResultResolveFn(resolve);
		});
	};
}
